import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from './utils';

export const contractorsApi = createApi({
  reducerPath: 'contractorsApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getContractorOptions: builder.query<string[], void>({
      query: () => '/v1/contractors/',
    }),
  }),
});

export const { useGetContractorOptionsQuery } = contractorsApi;

export const resetContractorsApiState = contractorsApi.util.resetApiState;
